import {Iso8601} from '../../validators/iso8601';

const nonIsoWarning = `
  dnb-date was given a string that was not in
  ISO 8601 format. Resulting date may be wrong.
`.trim();

const unqualifiedOffsetWarning = `
  dnb-date was given an ISO string that had an
  unqualified offset value. This would be interpreted
  as a local string in the machine parsing it based on
  where it is located. It was mangled to UTC for
  better consistency.
`.trim();

/**
 * Convert a DOM String attribute value into a Date object.
 *
 * @param attributeValue String representation of a date
 * @returns A date object that represents the requested string.
 */
export const fromAttribute = function(attributeValue: string): Date {
  // A date alone or a date and time can be
  // properly interpreted for display.
  const isNotValidIsoFormat = (
    Iso8601.isValidDateTime(attributeValue) === false &&
    Iso8601.isValidDate(attributeValue) === false
  );

  if (isNotValidIsoFormat === true) {
    console.debug(nonIsoWarning);
    return new Date(attributeValue);
  }

  // If the string is a date only, this is the
  // fastest to parse and build.
  if (Iso8601.isValidDate(attributeValue) === true) {
    let {year, month, day} = Iso8601.parseDateString(attributeValue);
    // JS months are referenced by index, not the
    // human-understood numbering.
    month = month - 1;
    return new Date(
        Date.UTC(
            year,
            month,
            day,
        ),
    );
  }

  const result = Iso8601.parseDateTimeString(
      attributeValue,
  );

  // If an offset is defined the string _should_ be
  // easily understood by any browser and consistently
  // parsed. So pass it right along, just in case
  // for some reason we get non-UTC offsets from
  // any content.
  const hasOffset = result.offset !== undefined;
  if (hasOffset === true) {
    return new Date(attributeValue);
  }

  console.debug(unqualifiedOffsetWarning);

  return new Date(
      Date.UTC(
          result.year,
          result.month - 1,
          result.day,
          result.hour,
          result.minute,
          result.seconds,
          result.milliseconds,
      ),
  );
};
